import React from 'react';
import Welcome from '../Sections/LoginPageSections/Welcome/welcome';

const LoginPage = () => {
  return <Welcome />;
};

export default LoginPage;
